// FollowButton.js
import React, { useState } from "react";
import styled from "styled-components";
import { color } from "../../utils/color";
import { apiCall } from "../../utils/apiCall";

// Define the styled button component
const StyledFollowButton = styled.button`
  margin-top: 10px;
  background-color: ${({ followed }) =>
    followed ? color.primary : color.secondary};
  color: ${({ followed }) => (followed ? "#ffffff" : "#000000")};
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  outline: none;

  &:hover {
    background-color: ${({ followed }) =>
      followed ? color.primaryDark : "#005e8a"};
  }
`;

// Create the FollowButton component
const FollowButton = ({ followed: followeed, id }) => {
  const [loading, setLoading] = useState(false);
  const [followed, setFollowed] = useState(followeed);

  const follow = async () => {
    setLoading(true);
    await apiCall(`users/follow/${id}`, "PUT", {})
      .then((response) => {
        if (response.status) {
          setFollowed(true);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <StyledFollowButton
      followed={followed}
      disabled={loading || followed}
      onClick={follow}
    >
      {loading ? "Loading" : followed ? "Following" : "Follow"}
    </StyledFollowButton>
  );
};

export default FollowButton;
